import { render, staticRenderFns } from "./DataConversionVW.vue?vue&type=template&id=5e4d1d81&scoped=true&"
import script from "./DataConversionVW.vue?vue&type=script&lang=js&"
export * from "./DataConversionVW.vue?vue&type=script&lang=js&"
import style0 from "./DataConversionVW.vue?vue&type=style&index=0&id=5e4d1d81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d1d81",
  null
  
)

/* custom blocks */
import block0 from "./DataConversionVW.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports